import { Map } from 'immutable';
import { createSelector } from 'reselect';
import TokenIcons from '../components/Wallet/Settings/TokenIcons';
import enumsSelectors from './enums/selectors';
import { twoKeyTokenSelector } from './wallet/selectors';


export const platformTokensSelector = createSelector(
  enumsSelectors.defaultTokens,
  twoKeyTokenSelector,
  /**
   * @param {Map<TokenInfo>} defaultTokens
   * @param {Map} twoKeyToken
   * @return {Map<string, TokenInfo>}
   */
  (defaultTokens = Map(), twoKeyToken = Map()) => (Map()).withMutations(map => {
    map.merge(defaultTokens);

    if (twoKeyToken) {
      map.set('2key', Map({
        symbol: twoKeyToken.get('token_symbol'),
        name: twoKeyToken.get('token_name'),
        id: twoKeyToken.get('token_web3_address'),
        address: twoKeyToken.get('token_web3_address'),
        decimals: twoKeyToken.get('token_decimals'),
        icon_url: TokenIcons['2KEY'],
      }));
    }

    map.set('eth', Map({
      symbol: 'ETH',
      name: 'Ethereum',
      address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
      decimals: 18,
      id: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
      icon_url: TokenIcons.ETH,
    }));
  })
);

export default {
  platformTokensSelector,
};
